import Embed from './embed';

class ImageEmbed extends Embed {
  static create(value) {
    const domNode = super.create({
      ...value,
      label: 'image',
      customTitle: this.title(value),
      iconName: 'photo',
      iconClass: '',
      buttons: ['edit'],
      denseMedia: true,
    });

    domNode.insertAdjacentHTML('beforeend', this.html(value));

    return domNode;
  }

  static title({
    caption = '',
    author = '',
  }) {
    return [caption, author].filter(Boolean).join(' / ');
  }

  static html({ src }) {
    return `
    <div class="ql-image-wrapper">
      <picture class="ql-image-figure">
          <img src="${src}" alt="" />
      </picture>
    </div>
    `;
  }

  static value(domNode) {
    const data = domNode.dataset;
    const value = {
      type: data.embedType,
      caption: data.embedCaption,
      author: data.embedAuthor,
      src: data.embedSrc,
    };

    if (data.embedType === ImageEmbed.TYPE.INTERNAL) {
      value.clippingId = data.embedClippingId;
    }
    return value;
  }

  /**
   * Types of embeded images.
   * @return {{EXTERNAL: string, INTERNAL: string}}
   */
  // Esto deberian ser los attributos del blot
  // que se representaria con la función estática
  // formats(domNode)
  static get TYPE() {
    return {
      EXTERNAL: 'external-image',
      INTERNAL: 'internal-image',
    };
  }
}

ImageEmbed.blotName = 'imageEmbed';
ImageEmbed.className = 'ql-image';
ImageEmbed.tagName = 'div';

export default ImageEmbed;
